import { Link } from "react-router-dom"

import style from "./style.module.scss"

import { APP_PAGE_URL } from "utils/env-management"

export function Community() {
    return (
        <Link
            to={`${APP_PAGE_URL}/community`}
            target="_blank"
            rel="noopener noreferrer"
            className={style.link}
        >
            Сообщество
        </Link>
    )
}
